import { cloneDeep } from "lodash";
import { Toastr } from "@revvsales/components";

import BaseCommand from "./baseCommand";

import { GlobalUtils, AmplitudeUtils } from "../utils";
import { EVENTS } from "../constants";

const { amplitudeLogEvent } = AmplitudeUtils;

const { validateEmail } = GlobalUtils;
class SignatureConfigChangeCommand extends BaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
    this.preventNukeActiveState = true;
  }

  execute() {
    const {
      data,
      isPdfDocument,
      isAdditionalFieldsChanged,
      signerIndex,
      updatedSignerConfig,
      setState,
      checkIfBlockGoingOutOfBound,
      onSectionUpdate,
    } = this.componentData;

    const newData = cloneDeep(data);

    // When adding additional fields, check if block is going out of bound
    if (isPdfDocument && isAdditionalFieldsChanged) {
      const currentOptionsCount = newData[
        signerIndex
      ].signer_config.options.filter(item => item.checked).length;
      const newOptionsCount = updatedSignerConfig.filter(item => item.checked)
        .length;
      // Trigger only if item is added
      if (newOptionsCount > currentOptionsCount) {
        const isBlockGoingOutOfBound = checkIfBlockGoingOutOfBound(
          newData[signerIndex],
        );
        if (isBlockGoingOutOfBound) {
          Toastr.showToastr({
            type: "warning",
            message:
              "Signature block is falling out of page. Reposition with adequate space below to add name and date tags.",
            timeout: 3000,
          });
          setState(() => ({ signBlocks: newData }));
          this.unDoable = false;
          return true;
        }
      }
    }
    newData[signerIndex].signer_config.options = updatedSignerConfig;

    if (!validateEmail(newData[signerIndex].signer_email)) {
      newData[signerIndex].internalUser = false;
      newData[signerIndex].signerEmail = "";
      newData[signerIndex].firstName = "";
      newData[signerIndex].lastName = "";
    }
    setState(() => ({ signBlocks: newData }));
    onSectionUpdate(newData[signerIndex], false, newData);

    if (updatedSignerConfig) {
      const amplitudeSignerConfig = [];
      updatedSignerConfig.forEach(config => {
        if (config.checked) {
          amplitudeSignerConfig.push(config.id);
        }
      });
      amplitudeLogEvent(EVENTS.EVENT_NAMES.SIGNATURE_BLOCK_EDITED, {
        Signercount: Array.isArray(newData) ? newData.length : null,
        SignatureFieldsActive: amplitudeSignerConfig,
      });
    }
    return true;
  }

  undo() {
    const {
      data,
      setState,
      onSectionUpdate,
      signerIndex,
      oldSignerConfig,
    } = this.componentData;
    const newData = cloneDeep(data);
    newData[signerIndex].signer_config.options = oldSignerConfig;
    setState(() => ({ signBlocks: newData }));
    onSectionUpdate(newData[signerIndex], false, newData);
  }
}

export default SignatureConfigChangeCommand;



// WEBPACK FOOTER //
// ./src/commands/signatureConfigChangeCommand.js